module.exports = __webpack_public_path__ + "img/Obstwanderung.77cc45d5.jpg";